import { useEffect, useState } from 'react'
import Cookies from 'js-cookie'
import useSearchParams from '@vero/ui-core-browser/hooks/search-params.js'
import useClaims from './claims.js'

export default function (allowLoginEmail = true, initialState = '') {
  const { claims } = useClaims()
  const { searchParams } = useSearchParams()
  const [email, setEmail] = useState(initialState)

  function clearEmail () {
    setEmail('')
    window.localStorage.removeItem('loginEmail')
    Cookies.remove('LAST_LOGIN_EMAIL')
  }

  function storeEmail (email) {
    if (email) {
      setEmail(email)
      window.localStorage.setItem('loginEmail', email)
    } else {
      clearEmail()
    }
  }

  useEffect(() => {
    setEmail(
      claims?.email || searchParams?.email || (allowLoginEmail && (window.localStorage.getItem('loginEmail') || Cookies.get('LAST_LOGIN_EMAIL'))) || initialState
    )
  }, [claims, searchParams])

  return {
    email,
    setEmail: storeEmail,
    clearEmail
  }
}
